function setCookieReferral(value) {
    document.cookie = `referral_acf_page=${encodeURIComponent(value)}; path=/; max-age=${60 * 60 * 24 * 30}; SameSite=Lax`;
}

function getCookieReferral() {
    const match = document.cookie.match(/(?:^|;\s*)referral_acf_page=([^;]*)/);
    return match ? decodeURIComponent(match[1]) : null;
}

function initReferralTracking() {
    if (window.location.hash.includes('referral')) {
        setCookieReferral('Referral');
        return;
    }

    if (getCookieReferral() === 'Referral') {
        return;
    }

    const meta = document.querySelector('meta[name="page-referral"]');
    if (meta) {
        setCookieReferral(meta.getAttribute('content'));
    }
}

export { initReferralTracking };
